import React, { useEffect } from "react";
import { Card, Col, Divider, Row, Typography, Table } from "antd";

const { Text } = Typography;

const Preview = (props) => {
  const {
    formData,
    configureLimitTableSource,
    configureTransactionTableSource,
    officeData,
    selectedOfficeName
  } = props;

  useEffect(() => {
    console.log(configureLimitTableSource);
    console.log(configureTransactionTableSource);
  }, []);

  console.log(formData.authForm)
  const data = {
    authForm: [
      {
        name: "Vault",
        value: selectedOfficeName},
      {
        name: "Till Profile Name",
        value: formData?.authForm?.description ,
      },
      {
        name: "Denomination Tracking",
        value: formData?.authForm?.allowDenomTracking ? "Enabled" : "Disabled",
      },
      {
        name: "Print Receipt ",
        value: formData?.authForm?.printTransactionReceipt ? "Enabled" : "Disabled",
      },
      {
        name: "Transaction Reversal",
        value: formData?.authForm?.allowTransactionReversal ? "Enabled" : "Disabled",
      },
    ],
  };

  const columns = [
    [
      {
        key: " 1",
        title: "Currency",
        dataIndex: "currencyCode",
      },
      {
        key: " 2",
        title: "Authorization Threshold",
        dataIndex: "authThresholdAmount",
      },
      {
        key: " 3",
        title: "Daily Transaction Limit",
        dataIndex: "transactionLimit",
      },
    ],
    // [
    //   {
    //     key: " 1",
    //     title: "Currency",
    //     dataIndex: "currencyCode",
    //   },
    //   {
    //     key: " 2",
    //     title: "Transaction Type",
    //     dataIndex: "transactionTypeValue",
    //   },
    //   {
    //     key: " 3",
    //     title: "Transaction Type Limit",
    //     dataIndex: "transactionTypeLimit",
    //   },
    // ],
  ];

  return (
    <Card
      style={{
        marginBottom: "2%",
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
      }}
    >
      {/* AUTH FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Branch Authorization"}
        </Divider>
        {data.authForm.map((detail, index) => {
          // console.log("detail", detail);

          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text className="of-bold-disable-input">{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* LIMITS FORM */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Branch Limits"}
        </Divider>
        <Table
          pagination={false}
          columns={columns[0]}
          dataSource={configureLimitTableSource}
        />
      </div>
      {/* TRANSACTION FORM */}
      {/* <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Branch Transaction Limits"}
        </Divider>
        <Table
          pagination={false}
          columns={columns[1]}
          dataSource={configureTransactionTableSource}
        />
      </div> */}
    </Card>
  );
};

export default Preview;
